// extracted by mini-css-extract-plugin
export var btn = "calc-module--btn--3dd73";
export var calc = "calc-module--calc--3c487";
export var calculator = "calc-module--calculator--e1ee6";
export var check = "calc-module--check--46219";
export var inner = "calc-module--inner--2e572";
export var input = "calc-module--input--4304e";
export var max = "calc-module--max--e5736";
export var min = "calc-module--min--badeb";
export var minus = "calc-module--minus--84c2f";
export var orders = "calc-module--orders--47acd";
export var plus = "calc-module--plus--ebc9c";
export var range = "calc-module--range--c4315";
export var rangevalue = "calc-module--rangevalue--89029";
export var reward = "calc-module--reward--5fda7";
export var sub = "calc-module--sub--83206";
export var sum = "calc-module--sum--fedd3";
export var wrapper = "calc-module--wrapper--6a099";